const OrigemAplicacaoRespostaEnum = {
    INICIAL: 'INICIAL',
    AMBIENTE: 'AMBIENTE',
    CARACTERIZACAO_PERIGO_RISCO: 'CARACTERIZACAO_PERIGO_RISCO'
}

export default OrigemAplicacaoRespostaEnum;
